webpackJsonp([6,21],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(214);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(13)
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(17)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */,
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      info: ""
	    };
	  },
	  ready: function ready() {
	    var self = this;
	    var str = window.location;
	    if (str.pathname == "/Consultant_center.html" || str.pathname == "/Consultant_show.html" || str.pathname == "/Consultant_detail.html") {
	      (0, _jquery2.default)("#myConsultantCenter").attr("class", "cur");
	    } else if (str.pathname == "/personalCenter.html") {
	      (0, _jquery2.default)("#myCenter").attr("class", "cur");
	    } else if (str.pathname == "/Ent_center.html") {
	      (0, _jquery2.default)("#myCompanyCenter").attr("class", "cur");
	    }
	    util.sendAjax({
	      type: "POST",
	      url: "loginStatus",
	      data: {},
	      success: function success(json) {
	        console.log(json);
	        if (json.success == true) {
	          if (json.data == "true") {
	            util.sendAjax({
	              type: 'POST',
	              url: 'mem/queryOwnMemInfo',
	              data: {},
	              success: function success(json) {
	                console.log(json);
	                if (json.success == true) {
	
	                  (0, _jquery2.default)("#userName").show();
	                  (0, _jquery2.default)("#login").hide();
	                  (0, _jquery2.default)("#register").hide();
	                  (0, _jquery2.default)("#myCenter").show();
	                  (0, _jquery2.default)("#logout").show();
	                  self._data.info = json.data.mobilePhone;
	                } else {
	                  (0, _jquery2.default)("#userName").hide();
	                  (0, _jquery2.default)("#login").show();
	                  (0, _jquery2.default)("#register").show();
	                  (0, _jquery2.default)("#myCenter").hide();
	                  (0, _jquery2.default)("#logout").hide();
	                }
	              }
	            });
	
	            var myRole = userInfo.getRole();
	            console.log(myRole);
	            if (util.isVal(myRole) != "") {
	              if (myRole.memRole == "true") {
	                (0, _jquery2.default)("#myCenter").show();
	              }
	              if (myRole.entRole == "true") {
	                (0, _jquery2.default)("#myCompanyCenter").show();
	              }
	              if (myRole.resRole == "true") {
	                (0, _jquery2.default)("#myConsultantCenter").show();
	              }
	            } else {
	              if (str.pathname == "/" || str.pathname == "index.html") {
	                layer.msg("您还没有登录!");
	              } else {}
	            }
	          }
	        }
	      }
	    });
	  },
	  methods: {
	    isLogout: function isLogout() {
	      util.sendAjax({
	        type: "POST",
	        url: "logout",
	        data: {},
	        success: function success(data) {
	          if (data.success == true) {
	            window.location.href = "index.html";
	          }
	        }
	      });
	    }
	  }
	};

/***/ },
/* 16 */,
/* 17 */
/***/ function(module, exports) {

	module.exports = " <div class=site_nav _v-27f1bff1=\"\"> <div class=main_page _v-27f1bff1=\"\"> <a class=site_nav_tell href=javascript:; _v-27f1bff1=\"\"> 服务热线： 010-68710020 </a> <a class=site_nav_email href=javascript:; _v-27f1bff1=\"\"> 服务邮箱：service@ewisest.com </a> <ul class=site_nav_menu _v-27f1bff1=\"\"> <li id=userName _v-27f1bff1=\"\"><a href=javascript:; _v-27f1bff1=\"\">欢迎：{{info}}</a></li> <li class=cur id=login _v-27f1bff1=\"\"><a href=login.html _v-27f1bff1=\"\">登录</a></li> <li id=register _v-27f1bff1=\"\"><a href=register.html _v-27f1bff1=\"\">免费注册</a></li> <li id=myCenter _v-27f1bff1=\"\"><a href=personalCenter.html _v-27f1bff1=\"\">我的中心</a></li> <li id=myConsultantCenter style=display:none _v-27f1bff1=\"\"><a href=Consultant_center.html _v-27f1bff1=\"\">顾问中心</a></li> <li id=myCompanyCenter style=display:none _v-27f1bff1=\"\"><a href=Ent_center.html _v-27f1bff1=\"\">企业中心</a></li> <li class=no_border _v-27f1bff1=\"\"><a href=service_law.html _v-27f1bff1=\"\">帮助与支持</a></li> <li class=no_border id=logout style=display:none _v-27f1bff1=\"\"><a href=javascript:; @click=isLogout _v-27f1bff1=\"\">退出</a></li> <li class=\"no_border site_nav_menu_map\" _v-27f1bff1=\"\"><a href=javascript:; _v-27f1bff1=\"\">导航</a></li> </ul> </div> </div> ";

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(30)
	__vue_template__ = __webpack_require__(32)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=footer _v-fc19f102=\"\"> <div class=main_page _v-fc19f102=\"\"> <h1 _v-fc19f102=\"\"> <a href=index.html _v-fc19f102=\"\"> <img src=" + __webpack_require__(28) + " style=width:150px _v-fc19f102=\"\">融聚智慧 | 创造价值</a> </h1> <ul style=width:400px;overflow:inherit _v-fc19f102=\"\"> <li _v-fc19f102=\"\"> <a href=../platform.html _v-fc19f102=\"\">平台服务机制</a> <a href=../useragreement.html _v-fc19f102=\"\">用户协议</a> </li> <li _v-fc19f102=\"\"> <a href=../privacy.html _v-fc19f102=\"\">隐私政策</a> <a href=../cookie.html _v-fc19f102=\"\">cookie政策</a> </li> </ul> <div class=\"col-sm-3 phone\" style=overflow:hidden;width:220px;height:50px;padding-top:30px;float:left _v-fc19f102=\"\"> <a class=site_nav_tell href=010-68498888 style=font-size:15px;width:220px _v-fc19f102=\"\"> 服务热线： 010-68498888 </a> </div> <div class=weixin_nav _v-fc19f102=\"\"> <img src=" + __webpack_require__(33) + " _v-fc19f102=\"\"> <p _v-fc19f102=\"\">关注亿汇智</p> </div> <p style=padding-top:120px _v-fc19f102=\"\">Copyright 2015, eWisest, All Rights Reserved <a style=\"color: #919191\" href=http://www.miitbeian.gov.cn/ _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\">京ICP备15058518号 </a></p><a style=\"color: #919191\" href=http://www.miitbeian.gov.cn/ _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\"> </a></div><a style=\"color: #919191\" href=http://www.miitbeian.gov.cn/ _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\"> </a></div><a style=\"color: #919191\" href=http://www.miitbeian.gov.cn/ _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\" _v-fc19f102=\"\"> </a>";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/weixin.9c68e9f.png";

/***/ },
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(98)
	__vue_script__ = __webpack_require__(100)
	__vue_template__ = __webpack_require__(101)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 98 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 99 */,
/* 100 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = " <div class=toolbar> <a href=javascript:scroll(0,0) id=top class=\"toolbar-item toolbar-item-top\"></a> </div> ";

/***/ },
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(215)
	__vue_script__ = __webpack_require__(217)
	__vue_template__ = __webpack_require__(269)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 215 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 216 */,
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Case = __webpack_require__(218);
	
	var _Case2 = _interopRequireDefault(_Case);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vcase: _Case2.default
	  }
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(219)
	__vue_script__ = __webpack_require__(221)
	__vue_template__ = __webpack_require__(268)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 219 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 220 */,
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Head = __webpack_require__(12);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _HeaderNav = __webpack_require__(222);
	
	var _HeaderNav2 = _interopRequireDefault(_HeaderNav);
	
	var _Foot = __webpack_require__(29);
	
	var _Foot2 = _interopRequireDefault(_Foot);
	
	var _router = __webpack_require__(227);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vhead: _Head2.default,
	    vfooter: _Foot2.default,
	    Router: _router2.default,
	    vheadnav: _HeaderNav2.default
	  }
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(223)
	__vue_script__ = __webpack_require__(225)
	__vue_template__ = __webpack_require__(226)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 223 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 224 */,
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Head = __webpack_require__(12);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Service = __webpack_require__(97);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      info: {},
	      allConsultantSize: "",
	      allEntSize: ""
	    };
	  },
	  methods: {
	    markConsultant: function markConsultant(val) {
	      var self = this;
	
	      var myMessage = userInfo.getMember();
	      if (util.isVal(myMessage) != "") {
	        self._data.info = myMessage;
	      } else {
	        self._data.info = "";
	      }
	
	      if (util.isVal(self._data.info.id) == "") {
	        layer.msg("请先登陆！");
	        window.location.href = "login.html";
	      } else {
	        if (val == "res") {
	          window.location.href = "personalCenter.html#!/basicInfo";
	        } else if (val == "ent") {
	          window.location.href = "personalCenter.html#!/company_basicInfo";
	        } else if (val == "eadvice") {
	          window.location.href = "eadvice.html";
	        }
	      }
	    }
	  },
	  components: {
	    vhead: _Head2.default,
	    vservice: _Service2.default
	  }
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=nav> <div class=main_page> <h1> <a href=index.html> <img src=" + __webpack_require__(28) + " />融聚智慧 | 创造价值</a> </h1> <ul class=nav_menu> <li class=\"\"><a href=javascript:; @click=\"markConsultant('eadvice')\">易咨询</a></li> <li><a href=javascript:;>亿学堂</a></li> <li><a href=javascript:;>顾问家</a></li> <li class=last><a href=javascript:;>企业俱乐部</a></li> </ul> </div> </div> ";

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(35);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _zqys = __webpack_require__(228);
	
	var _zqys2 = _interopRequireDefault(_zqys);
	
	var _index = __webpack_require__(233);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _zsy_esales = __webpack_require__(236);
	
	var _zsy_esales2 = _interopRequireDefault(_zsy_esales);
	
	var _zh_crude = __webpack_require__(243);
	
	var _zh_crude2 = _interopRequireDefault(_zh_crude);
	
	var _sqdz_information = __webpack_require__(247);
	
	var _sqdz_information2 = _interopRequireDefault(_sqdz_information);
	
	var _zsy_infostrategy = __webpack_require__(251);
	
	var _zsy_infostrategy2 = _interopRequireDefault(_zsy_infostrategy);
	
	var _win = __webpack_require__(254);
	
	var _win2 = _interopRequireDefault(_win);
	
	var _visa = __webpack_require__(259);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _lenven_num = __webpack_require__(264);
	
	var _lenven_num2 = _interopRequireDefault(_lenven_num);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default();
	
	router.map({
	  '/zqys': {
	    component: _zqys2.default
	  },
	  '/zsy_esales': {
	    component: _zsy_esales2.default
	  },
	  '/zh_crude': {
	    component: _zh_crude2.default
	  },
	  '/sqdz_infor': {
	    component: _sqdz_information2.default
	  },
	  '/zsy_infostrategy': {
	    component: _zsy_infostrategy2.default
	  },
	  '/win': {
	    component: _win2.default
	  },
	  '/visa': {
	    component: _visa2.default
	  },
	  '/lenven_num': {
	    component: _lenven_num2.default
	  }
	
	});
	
	router.redirect({
	  '/': '/zqys'
	});
	
	window.onload = function () {
	  router.start(_index2.default, '#app');
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(229)
	__vue_template__ = __webpack_require__(230)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 229 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">中企云商大宗散货交易平台</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 中企云商是一家致力于发展“大宗商品供应链集成服务”和“基础设施建设综合服务”两大领域的开放型“生产性服务电商”。 中企云商服务于大宗商品供应链中的生产企业、贸易企业、终端用户、物流企业、金融机构等各类用户，为用户提供真实、 安全、便捷、高效的交易服务，“门到门”、“一条龙”式的物流服务，并通过供应链金融服务实现大宗商品供应链的闭环运行， 建立健康的大宗商品供应链生态体系。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <ol class=STYLE1 style=\"text-indent:2em;margin-top: 10px\"> <li> 1、实现平台服务的多样化，提供交易商城、竞价大厅、信息咨询、集采大厅、企业专区、仓储物流、金融服务等各类特色功能，为客户提供“一站式”服务。 </li> <li>2、实现阳光采购，为产业降低成本、为用户创造价值，成为让客户信赖的企业。</li> <li>3、资金流、物流全过程跟踪管控，解决大宗交易“诚信”问题，降低贸易风险。 </li> </ol> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em; font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “中企云商建立的大宗散货集采交易平台，实现了线下交易、线下物流和供应链金融的闭环运行，能服务于企业的集中采购， 搭建了以供应链金融为核心手段的共享采购服务平台。” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">中企云商科技股份有限公司客户</p> <p align=center class=STYLE1 style=\"margin-top: 50px\"><img width=554 height=249 src=" + __webpack_require__(231) + " /><br/> <span class=STYLE2>图一、PC端</span></p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554 height=249 src=" + __webpack_require__(232) + " /><br/> <span class=STYLE2>图二、手机端</span> </p> </div> </div> ";

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/zqys-1.f6303da.png";

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/zqys-2.eaf08b6.png";

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(234)
	__vue_template__ = __webpack_require__(235)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Head = __webpack_require__(12);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {},
	    components: {
	        vhead: _Head2.default
	    }
	};

/***/ },
/* 235 */
/***/ function(module, exports) {

	module.exports = " <div> <router-view></router-view> </div> ";

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(237)
	__vue_template__ = __webpack_require__(238)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 237 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">中国石油电子销售平台业务模式设计</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 在石油供需市场的大环境下，中国石油销售公司积极推行业务的互联网+、顺应新零售发展， 实现由油品提供商向综合服务商的转型。中国石油销售公司在多年互联网应用的基础上， 于2017年启动2B与2C领域电子销售平台的建设，建设前期，由亿汇智对其2B、2C领域电子商 务的业务模式进行统一规划。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <ol class=STYLE1 style=\"text-indent:2em;margin-top: 10px\"> <li> 1、\t明确了中国石油销售公司2B、2C电子商务的战略目标、实现路径 </li> <li>2、\t规划了中国石油销售公司2B、2C电子商务的目标客户、价值主张、渠道通路、 客户关系、核心资源、关键业务、重要合作伙伴、业务实现路线</li> <li>3、\t规划了中国石油销售公司2B、2C电子商务的高阶业务流程</li> <li>4、\t对商城、O2O、支付等关键业务的运行模式给出了决策建议</li> <li>5、\t规划了中国石油销售公司电子销售平台的应用架构、系统实施路线</li> </ol> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “电子销售平台业务模式设计方向明确、路径清晰、架构合理，关键业务运行模式决策建议为电商业务 的落地开展提供了很好的基础。” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">中国石油销售公司客户</p> <p align=center class=STYLE1 style=\"margin-top: 50px\"><img width=554 height=249 src=" + __webpack_require__(239) + " /><br/> <span class=STYLE2>图一、现状分析阶段报告</span></p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554 height=249 src=" + __webpack_require__(240) + " /><br/> <span class=STYLE2>图二、业务模式设计报告</span> </p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554 height=249 src=" + __webpack_require__(241) + " /><br/> <span class=STYLE2>图三、高阶业务流程分析报告</span> </p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554 height=249 src=" + __webpack_require__(242) + " /><br/> <span class=STYLE2>图四、应用架构设计报告</span> </p> </div> </div> ";

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/esales-1.c2ef90d.png";

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/esales-2.e48d9de.png";

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/esales-3.9922140.png";

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/esales-4.aa4360c.png";

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(244)
	__vue_template__ = __webpack_require__(245)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">国家电网电子商务十三五规划</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 为培育新的业务和效益增长点，响应国家“互联网+”行动计划，准确把握互联网经济发展机遇， 利用互联网技术推动传统业务转型升级，按照国家电网总体安排，开展“十三五”发展规划研究和编制工作。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <ol class=STYLE1 style=\"text-indent:2em;margin-top: 10px\"> <li> 1、\t帮助国家电网完成电子商务领域复杂的战略决策过程，确立电子商务和互联网金融发展的宏观方向和 具体道路，指导国网电商十三五阶段的整体思路； </li> <li>2、\t在新形势下，确立国网在电子商务领域的顶层设计，为基层首创指明战略意图，利用十三五的契机， 实现跨越发展。 </li> </ol> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em; font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “规划立足现有业务和资源的基础，放眼未来电子商务和互联网金融产业发展，聚焦战略新兴行业领域，打造平台、储备能力、创新模式，为支撑国家电网公司的创新发展战略，促进国网电商公司电子商务、 互联网金融等业务长足发展提供基本指导。” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">国家电网电商公司业务主管副总经理</p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img style=\"width:300px;height: 350px\" src=" + __webpack_require__(246) + " /><br/> <span class=STYLE2>图一</span></p> </div> </div> ";

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/crude-2.29ed2b4.png";

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(248)
	__vue_template__ = __webpack_require__(249)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 248 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">上汽大众销售公司信息战略规划</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 随着市场环境的变化，竞争日益加剧。面对挑战，上汽大众汽车有限公司积极调整转型， 以客户和市场为导向打造体系竞争力，销售公司在双品牌战略、区域市场战略、渠道能力提升、 核心流程优化、服务体系升级、数字化营销等诸多方面进行了卓有成效的转型和改善，在客户和 市场为导向的调整转型过程中，上汽大众深刻地体会到信息化建设对支撑企业战略、提升企业运 营管理能力，提升执行力的重要性。因此，2016年12月份启动信息化建设规划项目。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 通过规划使得上汽大众能够有序地构建企业信息技术体系，有计划地提升企业信息化能力，使信息 化成为支撑上汽大众未来发展的持久推动力，实现信息化投资的业务价值最大化。 </p> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “本次规划充分考虑了当今信息化，尤其是营销业务领域快速发展变化趋势，切实制定了基于SOA的企 业架构，识别了关键业务服务，清晰规划了共享服务中心，为下一步汽车销售、客户服务所需的灵活、 易扩展、开放的信息化应用建设奠定了基础。” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">上汽大众销售公司IT负责人 </p> <p align=center class=STYLE1 style=\"margin-top: 50px\"><img width=554 height=249 src=" + __webpack_require__(250) + " /><br/> <span class=STYLE2>图一、蓝图设计报告</span></p> </div> </div> ";

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/info-1.03b91ac.png";

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(252)
	__vue_template__ = __webpack_require__(253)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 252 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 253 */
/***/ function(module, exports) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">中国石油非油业务信息战略规划</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 在中国石油销售公司发展战略中，非油业务已经成为公司持续盈利发展的战略性业务。 2017年正式成立昆仑好客公司，推动非油业务的规模化、品牌化、专业化。为了在新零售时代下， 实现非油业务目标，充分发挥数字化、互联网+对非油业务客户管理、品类管理、营销、销售、 采购、配送物流等业务领域的积极推动与变革作用，2017年9月份启动非油信息战略规划。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 明确了未来便利店、汽服、餐饮业务的发展趋势及信息化需求，设计了未来非油业务信息化的信息架构、 应用架构、信息化项目投资估算、制定了非油业务信息化的实施路线。 </p> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “本次规划全面分析了加油站非油业务便利店、汽服、餐饮等细分业务的发展趋势， 充分考虑了新零售时代数字化转型优势， 兼具前瞻性、可落地性，将有力支持中国石油非油业务战略的实现” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">昆仑好客公司客户</p> </div> </div> ";

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(255)
	__vue_template__ = __webpack_require__(256)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">唐山双赢物流信息系统建设</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 经过几年的业务发展，双赢物流的业务已经深入到社会生产企业中， 已经能提供基本的物流服务和部分的增值服务，竞争对手均已建设 成功可以服务高端客户的综合性一体化信息系统，抢占国内高价值 企业，并将信息系统深化至客户内部，而唐山双赢现有的信息系统 多为本企业自用，无法满足面向社会的服务能力。为了支撑未来业 务发展及提升竞争力的要求，于2016年启动物流信息系统的建设项目。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 建设了以业务流程标准化、管理精细化为核心的综合决策管理系统、 以大客户（钢厂）为依托的运输、仓储、融资、综合决策支持管理 的服务保障系统并向供应链上下游业务延伸。系统支撑公司运输、 钢厂内倒、仓储、客户（钢厂）融资、综合决策分析，实现全面的 业务流程化、标准化管理，强化决策支持功能，全面实现业务的电 子化管理。建设了车货匹配平台，打造跨区域的物流资源整合平台， 在平台上开展规模化的增值服务（保险、车辆维修、配件等服务）。 </p> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “本系统的成功建设，标注着双赢物流的资源匹配优化、资源利用率的最大化、 客户服务能力改善，即公司核心竞争力的大大提升” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">唐山双赢物流公司客户</p> <p align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554px height=249px src=" + __webpack_require__(257) + " /><br/> <span class=STYLE2>图一</span></p> <div align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554px height=300px src=" + __webpack_require__(258) + " /><br/> <span class=STYLE2>图二</span> </div> </div> </div> ";

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/win-1.042d802.jpg";

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/win-4.11197bc.png";

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(260)
	__vue_template__ = __webpack_require__(261)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 260 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">VISA银行信用卡APP创新</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 消费金融日益强调与生活场景的深度融合，为了帮助银行下从消费者需求出发， 挖掘生活场景中的消费金融需求，改善消费者体验，VISA在银行推广设计思维，推动应用创新 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 帮助中信银行围绕信用卡制定、设计了“e秒用卡”、“APP生活支付”、“无限卡私人秘书”、 “信用租赁”四大创新服务，并组织进行设计体验、内部测试、用户验证、优化迭代以及原型完成。 </p> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> “感谢教会了我们设计方法，使我们在产品创新时做到了天上和地下的完美结合” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">中信银行信用卡中心客户</p> <div align=center class=STYLE1 style=\"margin-top: 50px\"><img width=554 height=249 src=" + __webpack_require__(262) + " /><br/> <span class=STYLE2>图一、现场</span></div> <div align=center class=STYLE1 style=\"margin-top: 50px\"> <img width=554 height=500 src=" + __webpack_require__(263) + " /><br/> <span class=STYLE2>图二、APP</span> </div> </div> </div> ";

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/visa-1.a0b4642.png";

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/visa-2.deeae83.png";

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(265)
	__vue_template__ = __webpack_require__(266)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 265 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    ready: function ready() {},
	    methods: {}
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div> <div style=\"background-color:#FFFFFF;text-align:left; line-height:24px; padding:20px 60px; margin-top:20px;margin-bottom: 20px\"> <div style=\"font-weight:bold; font-size:20px; paddig-bottom:20px; width:100%; text-align:center;color:#53A5DE\">中国石油电子销售平台业务模式设计</div> <p style=\"font-weight: bold;margin-top: 50px\">案例背景</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 联想作为全球领先的IT设备及方案提供商，在互联网时代也在积极实施数字化转型， 并发布了联想的双态IT方法论，希望帮助不同类型客户根据他们自身的特点，提供 有联想特色的数字化应用方案。为了更好得支持联想在数字化业务领域与企业的沟通， 固化企业数字化转型方法和步骤，于2017年启动了联想数字化转型项目。 </p> <p style=\"font-weight: bold;margin-top: 20px\">关键效益</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"text-indent:2em;margin-top: 10px\"> 帮助联想形成了联想特色的“轻咨询”数字化转型规划方法及操作步骤，培训了联想核心技术团队， 并在联想售前团队与客户交流中得到广泛应用，提升了联想在帮助企业数字化转型及互联网+转型的能力。 </p> <p style=\"font-weight: bold;margin-top: 20px\">客户评价</p> <p align=left class=\"STYLE1 STYLE2 STYLE1\" style=\"line-height:2em;font-style: italic;text-indent:2em;margin-top: 10px;color: dimgray;font-size: 20px;font-family: cursive\"> 我们将充分应用数字化转型方法，实现我们由产品提供商向方案提供商的转型” </p> <p align=right style=\"font-size: 20px;font-family: cursive;font-style: italic\">联想售前经理</p> <p align=center class=STYLE1 style=\"margin-top: 50px\"><img width=554 height=249 src=" + __webpack_require__(267) + " /><br/> <span class=STYLE2>图一、现场</span></p> </div> </div> ";

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lenven-1.4cf714d.jpg";

/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports = " <vhead></vhead> <vheadnav></vheadnav> <div id=app> <router></router> </div> <vfooter></vfooter> ";

/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = " <vcase></vcase> ";

/***/ }
]);


// WEBPACK FOOTER //
// static/js/case.c954c5eec78ca384ea7c.js